import React, { useEffect, useState } from "react";
import { Switch, Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import { routeActions } from "../routes";

import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";

import login from "assets/img/login.jpeg";
//Redux
import { useSelector } from "react-redux";

const useStyles = makeStyles(styles);

export default function Pages() {
  // styles
  const classes = useStyles();
  const state = useSelector(state => state.auth);
  
  const [routes, setRoutes] = useState(routeActions.mapRoutes({
    layout: '/auth',
    auth: !!state.Token,
    userPermissions: state.Permissions
  }));

  useEffect(() => { 
    setRoutes(routeActions.mapRoutes({
      layout: '/auth',
      auth: !!state.Token,
      userPermissions: state.Permissions
    }));
  }, [state.Token, state.Permissions])

  return (
    <div>
      <div className={classes.wrapper}>
        <div
          className={classes.fullPage}
          style={{ backgroundImage: "url(" + login + ")" }}
        >
          <Switch>
            {routes}
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
        </div>
      </div>
    </div>
  );
}
